export default {
  primary: '#464653',
}
